import { Injectable } from '@angular/core';
import { SettingsService } from '../../shared/services/settings.service';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import * as fromActions from './settings.actions';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { SettingsAdapter } from './settings.adapter';
import { ISettingsResponse, ITimeZone, Settings } from '../../shared/models/settings.model';
import { of } from 'rxjs/internal/observable/of';
import { AlertService } from '../../shared/services/alert.service';


@Injectable()
export class SettingsEffects {
    constructor(
        private actions$: Actions,
        private settingsService: SettingsService,
        private alertService:AlertService
    ) {
    }

    
    loadSettings: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadSettings>(
            fromActions.SettingsActionTypes.LOAD_SETTINGS
        ),
        mergeMap((action: fromActions.LoadSettings) =>
          this.settingsService.getSettings(action.payload.department).pipe(
                switchMap((settings: ISettingsResponse) => SettingsAdapter.toSettings(settings)),
                map((settings: Settings) => new fromActions.LoadSettingsSuccess({ settings })),
                catchError(err => of(new fromActions.LoadSettingsFailure({ error: err })))
            )
        )
    ));

    
    loadZipCodes: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadZipcodes>(
            fromActions.SettingsActionTypes.LOAD_ZIPCODES
        ),
        mergeMap((action: fromActions.LoadZipcodes) =>
          this.settingsService.getPMAZipCodes(action.payload.department).pipe(
                switchMap((settings: ISettingsResponse) => SettingsAdapter.toSettings(settings)),
                map((zipcodes: string[]) => new fromActions.LoadZipcodesSuccess({ zipcodes })),
                catchError(err => of(new fromActions.LoadZipcodesFailure({ error: err })))
            )
        )
    ));

    
    loadTimezones: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadTimezones>(
            fromActions.SettingsActionTypes.LOAD_TIMEZONES
        ),
        mergeMap((action: fromActions.LoadTimezones) =>
            this.settingsService.getTimezones().pipe(
                map((timezones: ITimeZone[]) => new fromActions.LoadTimezonesSuccess({ timezones })),
                catchError((error) => of(new fromActions.LoadTimezonesFailure({ error })))
            )
        )
    ));

    
    updateSettings: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.UpdateSettings>(
            fromActions.SettingsActionTypes.UPDATE_SETTINGS
        ),
        mergeMap((action: fromActions.UpdateSettings) =>
          this.settingsService.updateSettings(action.payload.department, action.payload.settings).pipe(
            switchMap((updateResponse:ISettingsResponse) => SettingsAdapter.toSettings(updateResponse)),
            map(
                (updatedSettings: Settings) => {
                    this.alertService.showAlert('otherTexts.settingsUpdatedSuccessfully', '', '', 5000, false);
                   return new fromActions.UpdateSettingsSuccess({settings : updatedSettings})
                },
            ),
            catchError(err => {
              this.alertService.showAlert('otherTexts.somethingWentWrongPleaseTryAgain');
              return  of(new fromActions.UpdateSettingsFailure({ error: err }))
            })
        ))
    ));

}

